import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Button, styled } from '@mui/material';

// const WHATSAPP_HREF = 'https://wa.me/918031196612';

const Section = styled(Box)({
    position: 'relative',
    padding: '120px 0 40px',
    minHeight: 'auto',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFF 100%)',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '10%',
        left: '0',
        width: '100%',
        height: '80%',
        background: 'radial-gradient(ellipse 60% 40% at 30% 50%, rgba(0, 102, 255, 0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '20%',
        right: '5%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(99, 102, 241, 0.04) 0%, transparent 70%)',
        borderRadius: '50%',
        filter: 'blur(80px)',
        pointerEvents: 'none',
    },
    '@media (max-width: 968px)': {
        minHeight: 'auto',
        padding: '110px 0 44px',
    },
    '@media (max-width: 600px)': {
        padding: '100px 0 36px',
    },
});

const Content = styled(Box)({
    position: 'relative',
    zIndex: 1,
    width: '100%',
    textAlign: 'left',
    '@media (max-width: 968px)': {
        textAlign: 'center',
    },
});

const Title = styled(Typography)({
    fontSize: '60px',
    fontWeight: 600,
    lineHeight: 1.1,
    marginBottom: '28px',
    color: '#111827',
    textAlign: 'center',
    letterSpacing: '-2px',
    '@media (max-width: 968px)': {
        fontSize: '48px',
        letterSpacing: '-1.5px',
    },
    '@media (max-width: 600px)': {
        fontSize: '38px',
        letterSpacing: '-1.2px',
    },
    '@media (max-width: 480px)': {
        fontSize: '32px',
        letterSpacing: '-1px',
    },
});

const Description = styled(Typography)({
    fontSize: '20px',
    lineHeight: 1.6,
    color: '#6B7280',
    textAlign: 'center',
    marginBottom: '40px',
    '@media (max-width: 968px)': {
        fontSize: '18px',
        margin: '0 auto 32px',
        textAlign: 'center',
    },
    '@media (max-width: 600px)': {
        fontSize: '16px',
    },
});

const CtaRow = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '@media (max-width: 968px)': {
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
    },
});

const PrimaryButton = styled(Button)({
    padding: '16px 32px',
    fontSize: '15px',
    fontWeight: 600,
    borderRadius: '12px',
    textTransform: 'none',
    background: 'linear-gradient(135deg, #0066FF, #0052CC)',
    color: '#FFFFFF',
    minWidth: '190px',
    boxShadow: '0 4px 20px rgba(0, 102, 255, 0.3)',
    '&:hover': {
        background: 'linear-gradient(135deg, #0052CC, #003D99)',
        transform: 'translateY(-2px)',
        boxShadow: '0 10px 28px rgba(0, 102, 255, 0.35)',
    },
    '@media (max-width: 968px)': {
        width: '100%',
    },
});

const SecondaryButton = styled(Button)({
    padding: '16px 32px',
    fontSize: '15px',
    fontWeight: 500,
    borderRadius: '12px',
    textTransform: 'none',
    color: '#374151',
    borderColor: '#D1D5DB',
    borderWidth: '1.5px',
    background: '#FFFFFF',
    minWidth: '230px',
    '&:hover': {
        borderColor: '#0066FF',
        color: '#0066FF',
        background: 'rgba(0, 102, 255, 0.03)',
    },
    '@media (max-width: 968px)': {
        width: '100%',
    },
});

const HeaderSection = () => {
    return (
        <Section component="section" aria-label="Pricing">
            <Container maxWidth="xl">
                <Content>
                    <Title variant="h1">
                        Plans built for rehab centers where sessions, records, and payouts all have to work together.
                    </Title>
                    <Description>
                        Every plan starts with verified sessions and structured records. Payout workflows expand
                        with your team.
                    </Description>
                    <CtaRow>
                        <PrimaryButton component={Link} to="/demo" variant="contained">
                            Book a demo
                        </PrimaryButton>
                        <SecondaryButton
                            component="a"
                            href="https://wa.me/919187644794"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="outlined"
                        >
                            Talk to us on WhatsApp
                        </SecondaryButton>
                    </CtaRow>
                </Content>
            </Container>
        </Section>
    );
};

export default HeaderSection;
